import { 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function ImportSubmission() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body1" paragraph>
        The Import Submission endpoint is used to submit a DDS statement for import operations 
        bringing goods into the EU. This specialized endpoint includes specific fields relevant
        to import activities.
      </Typography>
      
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Endpoint
      </Typography>
      <CodeBlock code="POST /api/eudr/dds" />
      
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Request Body
      </Typography>
      <CodeBlock 
        code={`{
  "operatorType": "OPERATOR",
  "statement": {
    "internalReferenceNumber": "FR-000001",
    "activityType": "IMPORT",
    "countryOfActivity": "FR",
    "borderCrossCountry": "FR",
    "comment": "Some comments for the CA",
    "commodities": [{
      "descriptors": {
        "descriptionOfGoods": "here is the description of goods",
        "goodsMeasure": {
          "volume": 20,
          "netWeight": 40,
          "supplementaryUnit": 10,
          "supplementaryUnitQualifier": "MTQ"
        }
      },
      "hsHeading": "1806",
      "speciesInfo": {
        "scientificName": "Test",
        "commonName": "Test"
      },
      "producers": [{
        "country": "FR",
        "name": "Producer 1",
        "geometryGeojson": "eyJ0eXBlIjoiRmVhdHVyZUNvbGxlY3Rpb24iLCJmZWF0dXJlcyI6W3sidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7IlByb2R1Y3Rpb25QbGFjZSI6IkZhcm0gMSJ9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiUG9seWdvbiIsImNvb3JkaW5hdGVzIjpbW1szLjUzNzU5OCw0NC44NDAyOTFdLFs0Ljg1NTk1Nyw0Ni4zNzcyNTRdLFs1LjQyNzI0Niw0NC45NjQ3OThdLFszLjUzNzU5OCw0NC44NDAyOTFdXV19fV19"
      }]
    }],
    "geoLocationConfidential": false
  }
}`} 
      />

      <Typography variant="body1" paragraph sx={{ mt: 3 }}>
        <strong>Key Parameters Specific to Import Submission:</strong>
      </Typography>
      
      <TableContainer component={Paper} sx={{ mt: 1, mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Parameter</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>activityType</TableCell>
              <TableCell>"IMPORT" specifies this is an import operation</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>countryOfActivity</TableCell>
              <TableCell>Country code where the import activity is taking place</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>borderCrossCountry</TableCell>
              <TableCell>Country code where goods cross the EU border</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>hsHeading</TableCell>
              <TableCell>Harmonized System code for the commodity</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Response
      </Typography>
      <CodeBlock 
        code={`{
  "status": "success",
  "httpStatus": 201,
  "data": {
    "ddsIdentifier": "3f09ab3f-4c97-4663-8463-89d58f1d646b"
  }
}`} 
      />
      
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Response Codes
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>201</TableCell>
              <TableCell>DDS statement successfully created</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>Bad request - missing or invalid parameters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - invalid credentials</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>500</TableCell>
              <TableCell>Server error</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ImportSubmission; 